import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  curIndicators: { curOver: 'MA', curInd: 'MACD' },
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_CHART_INDICATOR:
      return { ...state, curIndicators: { ...state.curIndicators, ...action.curInd } };
    default:
      return state;
  }
};
